import ServiceEndpoint = OSF.ServiceEndpoint;
import { lazyUpdateAddinPinStatus, AddinPinModes } from 'owa-outlook-service-options';
import 'owa-addins-osfruntime';

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'UpdateAddinPinOptions',
        (data: any) => {
            var pinModes: AddinPinModes = {
                readMode: data[2],
                composeMode: data[3],
                calendarMode: data[4],
            };
            lazyUpdateAddinPinStatus.importAndExecute(data[0], data[1], pinModes);
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}
